import context from '@/context'
import { getStore } from '@/store'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { actionCreators as identityActions } from '@/store/Identity'
import { dialogTypes } from '@/dialogs'
import { push } from 'react-router-redux'
import { openErrorDialog } from '@/utils/dialogHelpers'

function switchInstitution (e, institutionId, url, callback) {
  if (e) {
    e.preventDefault()
  }

  if (context.isReportApp() &&
  !isNaN(institutionId) &&
  parseInt(institutionId) !== parseInt(getStore().getState().identity.user.profile.InstitutionId)) {
    getStore().dispatch(dialogActions.openDialog({
      dialogType: dialogTypes.confirm,
      title: 'Common.InstitutionSwitching',
      content: 'Common.InstitutionSwitchingBody',
      onAction: () => {
        context.api.institutionService.selectInstitution(institutionId)
          .then(() => {
            return getStore().dispatch(identityActions.refresh())
              .then(() => {
                RedirectOrDownload(url, callback)
              })
          }).catch(() => openErrorDialog())
      }
    }))
  } else {
    RedirectOrDownload(url, callback)
  }
}

function RedirectOrDownload (url, callback) {
  if (url) getStore().dispatch(push(url))
  if (callback) callback()
}

export { switchInstitution }



// WEBPACK FOOTER //
// ./src/utils/switchInstitution.js